<div class="d-grid gap-3" style="grid-template-columns: 350px 1fr" *ngIf="viewType !== 'table'">
  <app-automation-wizard-left
    [type]="type"
    (typeChange)="typeChange.emit($event)"
    image="/assets/images/automation-wizards/message.webp"
  >
    <ng-container i18n
      >Messages are communications between guests, hosts, or property managers within the system. Actions include
      sending, receiving, and tracking messages to ensure clear communication. This entity helps streamline guest and
      user interactions, fostering better coordination and customer service.</ng-container
    >
  </app-automation-wizard-left>
  <div class="card shadow">
    <div class="card-header flex-column align-items-start p-3 bg-default2">
      <h6 i18n>What would you like to do when a message is</h6>
      <div class="btn-group">
        <button
          type="button"
          (click)="onSelectEvent(events.GuestMessageCreated)"
          class="btn btn-sm"
          [ngClass]="selectedEvent === events.GuestMessageCreated ? 'btn-info' : 'btn-outline-light'"
          i18n
        >
          Received
        </button>
      </div>
    </div>
    <div class="card-body d-flex flex-column gap-3">
      <ng-container [ngSwitch]="selectedEvent">
        <ng-template *ngSwitchCase="events.GuestMessageCreated" [ngTemplateOutlet]="receivedEvent"></ng-template>
      </ng-container>
      <div class="flex-fill"></div>
    </div>
  </div>
</div>

<div *ngIf="viewType === 'table'" class="d-flex flex-column gap-4 automation-table">
  <div class="table-view-header text-muted text-semi-bold">
    <div class="text-uppercase text-muted mb-0" i18n>What would you like to do when</div>
    <div i18n>Created Date • Time</div>
    <div i18n>Last Triggered Date • Time</div>
  </div>
  <div class="container-box shadow">
    <h6 class="text-uppercase m-0 px-3 py-2" i18n>Message is Received</h6>
    <ng-template [ngTemplateOutlet]="receivedEvent"></ng-template>
  </div>
</div>

<ng-template #receivedEvent>
  <app-notify-users-automation
    [event]="events.GuestMessageCreated"
    [viewType]="viewType"
    [eventSourceType]="type"
    [handler]="eventHandlers.SendEmailMessage"
    i18n-label
    i18n-name
    label="Notify user(s) via Email"
    name="Notify user(s) via Email when message received"
    [messageSubject]="userNotificationMessages[events.GuestMessageCreated].subject"
    [messageBody]="userNotificationMessages[events.GuestMessageCreated].message"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-notify-users-automation>

  <app-notify-users-automation
    [event]="events.GuestMessageCreated"
    [viewType]="viewType"
    [eventSourceType]="type"
    [handler]="eventHandlers.SendPushNotification"
    i18n-label
    i18n-name
    label="Notify user(s) via Push Notification"
    name="Notify user(s) via Push Notification when message received"
    [messageBody]="userNotificationMessages[events.GuestMessageCreated].message"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-notify-users-automation>

  <app-notify-users-automation
    [event]="events.GuestMessageCreated"
    [viewType]="viewType"
    [eventSourceType]="type"
    [handler]="eventHandlers.SendSMSMessage"
    i18n-label
    i18n-name
    label="Notify user(s) via SMS"
    name="Notify user(s) via SMS when message received"
    [messageBody]="userNotificationMessages[events.GuestMessageCreated].message"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-notify-users-automation>

  <div [ngClass]="viewType === 'table' ? 'autopilot-automation table-view' : ''">
    <div class="panel" [class.active]="toggle1.checked">
      <app-form-switch
        labelPosition="before"
        [inline]="true"
        [formControl]="aiDraftCtrl"
        [matTooltip]="getTooltip1(toggle1.checked)"
        #toggle1
      >
        <ng-container i18n>Create AI based drafts</ng-container>
      </app-form-switch>
    </div>
  </div>
  <div [ngClass]="viewType === 'table' ? 'autopilot-automation table-view' : ''">
    <div class="panel" [class.active]="toggle2.checked">
      <app-form-switch
        labelPosition="before"
        [inline]="true"
        [formControl]="aiRespondCtrl"
        [matTooltip]="getTooltip2(toggle2.checked)"
        #toggle2
      >
        <ng-container i18n>Automatically send AI based message</ng-container>
      </app-form-switch>
    </div>
  </div>
  <app-do-action-automation
    [event]="events.GuestMessageCreated"
    [type]="type"
    [viewType]="viewType"
    [eventSourceType]="type"
    [handler]="eventHandlers.SendToZapier"
    label="Send it to Zapier"
    name="Send it to Zapier when message received"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-do-action-automation>
</ng-template>
